import api from "api";
import { Option } from "../components/styled/async-search-select-v2/AsyncSearchSelectV2.types";

interface SurgeryType {
  name: string;
  id?: string;
}

/**
 * Fetches surgery types from the API for use in dropdown/select components
 * @param search - Search term to filter surgery types
 * @returns Array of Option objects for use in AsyncSearchSelectV2
 */
export const fetchSurgeryTypes = async (search: string): Promise<Option[]> => {
  try {
    const response = await api.client.SurgeryType.list({
      search: search,
      size: 50,
    });

    if (response.body) {
      return response.body.map((surgeryType: SurgeryType) => ({
        value: surgeryType.name,
        label: surgeryType.name,
      }));
    }
    return [];
  } catch (error) {
    console.error("Error fetching surgery types:", error);
    return [];
  }
};

/**
 * Creates a surgery type option (used when creating new surgery types in forms)
 * @param name - Name of the surgery type to create
 * @returns Object with data structure expected by AsyncSearchSelectV2
 */
export const createSurgeryType = async (name: string) => {
  try {
    await api.client.SurgeryType.create({
      body: {
        surgery_type: {
          name: name,
        },
      },
    });
    return { data: { id: name } };
  } catch (error) {
    console.error("Error creating surgery type:", error);
    throw error;
  }
};
